export enum ErrorType {
  ABORT = "AbortError",
  TYPE = "TypeError",
  REFERENCE = "ReferenceError",
  SYNTAX = "SyntaxError",
  RANGE = "RangeError",
  NETWORK = "NetworkError",
  TIMEOUT = "TimeoutError",
}

